import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BuildCircleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"build_circle"}/>
}
